import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Mail, Instagram } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black pt-20">
      {/* Hero Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 via-yellow-900/5 to-transparent"></div>
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center animate-fade-in-up">
            <h1 className="font-heading text-4xl lg:text-6xl font-bold text-white mb-6">
              Contact Us
            </h1>
            
            <p className="text-xl lg:text-2xl text-gray-300 mb-12 leading-relaxed">
              Have a question or need support? We're here to help!
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-12 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Support Email Card */}
            <Card className="gaming-card p-8 text-center hover:scale-105 transition-all duration-300 animate-fade-in-up">
              <CardHeader className="pb-6">
                <div className="mx-auto mb-4 p-4 rounded-full w-20 h-20 flex items-center justify-center bg-yellow-400/20 border-2 border-yellow-400/30">
                  <Mail className="w-10 h-10 text-yellow-400" />
                </div>
                <CardTitle className="text-2xl text-white mb-2">Support Email</CardTitle>
              </CardHeader>
              <CardContent>
                <a 
                  href="mailto:support@fokatmain.com"
                  className="text-yellow-400 hover:text-yellow-300 font-semibold text-xl transition-colors hover:underline cursor-pointer"
                >
                  support@fokatmain.com
                </a>
              </CardContent>
            </Card>

            {/* Instagram Card */}
            <Card className="gaming-card p-8 text-center hover:scale-105 transition-all duration-300 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              <CardHeader className="pb-6">
                <div className="mx-auto mb-4 p-4 rounded-full w-20 h-20 flex items-center justify-center bg-blue-400/20 border-2 border-blue-400/30">
                  <Instagram className="w-10 h-10 text-blue-400" />
                </div>
                <CardTitle className="text-2xl text-white mb-2">Instagram</CardTitle>
              </CardHeader>
              <CardContent>
                <a 
                  href="https://instagram.com/getfokatmain"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 font-semibold text-xl transition-colors"
                >
                  @getfokatmain
                </a>
              </CardContent>
            </Card>
          </div>

          {/* Support Note */}
          <div className="text-center mb-16 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="bg-gradient-to-r from-yellow-400/10 via-blue-400/10 to-yellow-400/10 border border-yellow-400/20 rounded-2xl p-8 max-w-2xl mx-auto">
              <p className="text-gray-300 text-lg leading-relaxed mb-2">
                Our support team will respond as quickly as possible.
              </p>
              <p className="text-yellow-400 font-semibold text-xl">
                Keep playing & keep winning on FokatMain! 🎉
              </p>
            </div>
          </div>

          {/* Brand Partnerships Section */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <Card className="gaming-card p-8 bg-gradient-to-br from-blue-900/20 to-purple-900/20 border-blue-400/30">
              <CardHeader className="pb-4">
                <CardTitle className="text-2xl text-white text-center mb-2">
                  Brand Partnerships & Sponsorships
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-gray-400 mb-4">
                  For brand partnerships & sponsorship opportunities:
                </p>
                <a 
                  href="mailto:support@fokatmain.com?subject=Brand Partnership Inquiry"
                  className="text-yellow-400 hover:text-yellow-300 font-semibold text-xl transition-colors inline-flex items-center space-x-2"
                >
                  <Mail className="w-5 h-5" />
                  <span>support@fokatmain.com</span>
                </a>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Office Information Section */}
      <section className="py-16 bg-gradient-to-b from-transparent to-gray-900/50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="gaming-card p-8 animate-fade-in-up">
            <CardHeader className="pb-6">
              <div className="flex items-center justify-center mb-4">
                <div className="p-3 rounded-full bg-yellow-400/20">
                  <Mail className="w-6 h-6 text-yellow-400" />
                </div>
              </div>
              <CardTitle className="text-2xl text-white text-center">Office Information</CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-4">
              <div>
                <p className="text-gray-400 text-sm mb-1">Company Name</p>
                <p className="text-white font-semibold text-lg">PLAYEDGE INNOVATIONS</p>
              </div>
              <div>
                <p className="text-gray-400 text-sm mb-1">Brand</p>
                <p className="text-white font-semibold">Fokatmain (operated by PLAYEDGE INNOVATIONS)</p>
              </div>
              <div>
                <p className="text-gray-400 text-sm mb-1">Address</p>
                <p className="text-white font-semibold">Gurgaon, Haryana, India</p>
              </div>
              <div className="pt-4">
                <p className="text-gray-400 text-sm mb-1">Business Hours</p>
                <p className="text-white font-semibold">Monday - Friday: 9:00 AM - 6:00 PM IST</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Contact;
